import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/page/Home'
  import None from '@/page/None'
  
  
import Login from '@/page/Login'





Vue.use(Router)

// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

var router= new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
      name: 'Home',
      component: Home,
      children:[
        {
          path: '/none',
          name: 'None',
          component: None,
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})


import allRoute from '@/router/route'

router.$addRoutes = (params) => {
  router.matcher = new Router({mode: 'history'}).matcher;
  router.addRoutes(params)
}

// 全局路由守卫
  var array=[]
  var routeJson=[]
  if(localStorage.getItem('route2')){
    routeJson=localStorage.getItem('route2').split(',')
  }
  if(array.length!=routeJson.length&&localStorage.getItem('route2')){
    array=[]
    var arr=[
      {
        path: '/',
        redirect:'/none',
        name: 'Home',
          component: Home,
          children:[
            {
              path: '/none',
              name: 'None',
              component: None,
            }
          ]
      },
      {
        path: '/login',
        name: 'Login',
        component: Login,
      },
      {
        path:'*',
        redirect:'/none'
      }
    ]
    allRoute.map((item)=>{
      if(routeJson.indexOf(item.name)!=-1){
        array.push(item)
      }
    })
    arr[0].children=arr[0].children.concat(array)
    router.$addRoutes(arr)
  }
  router.beforeEach((to, from, next) => {
    if(from.path==='/login'){
      if(localStorage.getItem('route2')){
        routeJson=localStorage.getItem('route2').split(',')
      }
      if(array.length!=routeJson.length&&localStorage.getItem('route2')){
        array=[]
        var arr=[
          {
            path: '/',
            redirect:'/none',
            name: 'Home',
            component: Home,
            children:[
              {
                path: '/none',
                name: 'None',
                component: None,
              }
            ]
          },
          {
            path: '/login',
            name: 'Login',
            component: Login,
          },
          {
            path:'*',
            redirect:'/none'
          }
        ]
        allRoute.map((item)=>{
          if(routeJson.indexOf(item.name)!=-1){
            array.push(item)
          }
        })
        arr[0].children=arr[0].children.concat(array)
        router.$addRoutes(arr)
      }
    }
    let token = localStorage.getItem('token2')
    let userToken = localStorage.getItem('token')
    // 1. 判断是不是登录页面
    // 是登录页面
    if(to.path === '/login') {
      if(token=='CNC-admin'&&routeJson.length!=0 && userToken!=""){
        next('/none')
      }else{
        next()
      }
    } else {
      // 不是登录页面
      // 判断 是否登录过
      //后端请求判断token
      if(token=='CNC-admin'&&routeJson.length!=0 && userToken!=""){
        next()
      }else{
        //在新的实例上使用组件
        let v = new Vue();
        // console.log(v.axios)
        v.$alert('登录已超时', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            next('/login')
          }
        });
      }
    }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js